var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"app-footer d-sm-down-none",attrs:{"id":"footer"}},[_vm._v("\n\tCopyright 2020 Wildfire Labs.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }